import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import StarOutline from '@material-ui/icons/StarOutline';

const TypeRatingBar = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <StarOutline {...props} ref={ref} />
));

TypeRatingBar.displayName = 'TypeRatingBar';

export default TypeRatingBar;
